import React from "react";
import GearCode from "../../components/GearCode";
import GearQty from "../../components/GearQty";
import GearSize from "../../components/GearSize";
import MeshSize from "../../components/MeshSize";
import { getGearCodeValidation } from "../../constants/effortValidations";
import { validateGear, getInitialGearState } from "../../constants/Effort";

export default function EffortForm1(props) {
  if (props.currentStep !== 1) {
    return null;
  }
  let gearValidation = getGearCodeValidation(
    props.gearcode,
    props.gearCodeOptions
  );

  const handleGearCodeChange = (event, reason) => {
    event.preventDefault();
    let newState = new getInitialGearState();
    newState = { ...props.currentState, ...newState };
    if (
      reason &&
      reason.hasOwnProperty("CODE") &&
      reason.hasOwnProperty("NAME")
    ) {
      let gearValidations = props.gearCodeOptions;
      if (!Array.isArray(gearValidations)) {
        console.error("Not an array:", gearValidations);
        return false;
      }
      newState.gearcode = reason.CODE;
      newState.gearname = reason.NAME;
      newState = validateGear(gearValidations, reason.CODE, newState);
    }
    props.updateState({ ...newState });
  };

  const handleGearCodePreferenceChange = (event) => {
    event.preventDefault();
    let gearCode = event.currentTarget.dataset.gearCode;
    if (!gearCode) {
      console.log("No gear_code provided");
      return;
    }
    let newState = new getInitialGearState();
    newState = { ...props.currentState, ...newState };
    let gearValidations = props.gearCodeOptions;
    if (!Array.isArray(gearValidations)) {
      console.error("Not an array:", gearValidations);
      return false;
    }
    newState.gearcode = gearCode;
    newState = validateGear(gearValidations, gearCode, newState);
    props.updateState({ ...newState });
  };

  const handlePreferenceChange = (event) => {
    event.preventDefault();
    const { newValue, field } = event.currentTarget.dataset;
    if (!newValue) {
      console.log("No new value provided");
      return;
    }
    if (!field) {
      console.error("No field provided");
      return;
    }
    let newState = { ...props.currentState };
    newState[field] = newValue;
    props.updateState({ ...newState });
  };

  return (
    <div className="margAll10">
      <GearCode
        gearCodeOptions={props.gearCodeOptions}
        gearcode={props.gearcode}
        gearname={props.gearname}
        gear_preference={props.preferences.gear ? props.preferences.gear : []}
        changeHandler={handleGearCodeChange}
        handleGearCodePreferenceChange={handleGearCodePreferenceChange}
        helpText={props.helpText}
        reportType={props.reportType}
      />
      {props.showGearGty && (
        <GearQty
          gearqty={props.gearqty}
          gearcode={props.gearcode}
          handleInputChange={props.handleChange}
          handleGearPreferenceChange={handlePreferenceChange}
          gear_preference={props.preferences.gear ? props.preferences.gear : []}
          helpText={props.helpText}
          validation={gearValidation}
        />
      )}
      {props.showGearSize && (
        <GearSize
          gearsize={props.gearsize}
          gearcode={props.gearcode}
          handleInputChange={props.handleChange}
          handleGearPreferenceChange={handlePreferenceChange}
          gear_preference={props.preferences.gear ? props.preferences.gear : []}
          helpText={props.helpText}
          validation={gearValidation}
        />
      )}
      {props.showMeshSize && (
        <MeshSize
          mesh_size={props.mesh_size}
          gearcode={props.gearcode}
          handleInputChange={props.handleChange}
          handleGearPreferenceChange={handlePreferenceChange}
          gear_preference={props.preferences.gear ? props.preferences.gear : []}
          helpText={props.helpText}
          validation={gearValidation}
        />
      )}
    </div>
  );
}
